import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { Course, CourseDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getCourse(id: string): Observable<Course> {
        return this.httpClient.get<CourseDto>(`api/v1/library/courses/${id}`).pipe(
            map((response) => new Course(response)),
            catchError((error: HttpErrorResponse) => {
                console.log(error);
                if (error.status === 403) {
                    throw new Error('no-access');
                }
                throw error;
            }),
        );
    }
}
